// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"35ca3bb9","353":"23d12442","467":"66fa9208","490":"b6e5717a","493":"cdf8e124","896":"518e5a9a"}[chunkId] + ".chunk.css";
};